import { Component, Input, OnInit } from "@angular/core";
import {
  faChartPie,
  faChartLine,
  faChartLineDown,
  faChartBar,
  faChartColumn,
  faChartArea,
  faTable,
  faChartScatter,
  faCalendarAlt,
  faMap,
  faSitemap,
  faTrafficLightStop,
  faSpiderWeb,
  faTachometer,
  faChartNetwork,
  faAnalytics,
} from "@fortawesome/pro-duotone-svg-icons";
import { IconDefinition } from "@fortawesome/pro-duotone-svg-icons";

const ChartTypeIcons: {
  [key: string]: IconDefinition;
} = {
  table: faTable,
  line: faChartLine,
  Sparkline: faChartLine,
  bar: faChartBar,
  column: faChartColumn,
  area: faChartArea,
  pie: faChartPie,
  spline: faChartLineDown,
  scatter: faChartScatter,
  heat: faChartScatter,
  calendar: faCalendarAlt,
  maps: faMap,
  organization: faSitemap,
  stoplight: faTrafficLightStop,
  spiderweb: faSpiderWeb,
  arc: faTachometer,
  bubble: faChartNetwork,
  pareto: faAnalytics,
};

@Component({
    selector: "app-chart-icons",
    templateUrl: "./chart-icons.component.html",
    styleUrls: ["./chart-icons.component.scss"],
    standalone: false
})
export class ChartIconsComponent implements OnInit {
  @Input() icon!: any;
  @Input() type!: any;

  ngOnInit(): void {}

  /**
   * Returns the appropriate icon for dataPointType
   * @param type
   * @return IconDefinition | default: faQuestion
   */
  getChartTypeIcon(type: string): IconDefinition {
    if (type) type = type.toLowerCase();
    return ChartTypeIcons[type];
  }
}
